import { render, staticRenderFns } from "./topTitle.vue?vue&type=template&id=60e3ac3e&scoped=true"
import script from "./topTitle.vue?vue&type=script&lang=ts"
export * from "./topTitle.vue?vue&type=script&lang=ts"
import style0 from "./topTitle.vue?vue&type=style&index=0&id=60e3ac3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3ac3e",
  null
  
)

export default component.exports